import { render } from "./DeleteSchemaAction.vue?vue&type=template&id=69a559a0"
import script from "./DeleteSchemaAction.vue?vue&type=script&lang=ts"
export * from "./DeleteSchemaAction.vue?vue&type=script&lang=ts"
script.render = render

export default script